var exports = {
  "k": "xf0b3b88a--b83e69--container",
  "S": "xf0b3b88a--b83e69--image",
};

module.exports = exports;
